import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { BudgetLibraryState, BudgetLibraryStore } from './budget-library.store';

@Injectable({ providedIn: 'root' })
export class BudgetLibraryQuery extends QueryEntity<BudgetLibraryState> {
  protected store: BudgetLibraryStore;

  constructor() {
    const store = inject(BudgetLibraryStore);

    super(store);

    this.store = store;
  }
}
